/**
 * Load More & Filter functionality
 * Replaces all inline scripts for archive pages (events, posts, animals, conservation).
 */
export default function initLoadMore() {
    var container = document;

    var grid = container.querySelector('#posts-grid');
    if (!grid) return;

    // Prevent double-init on same grid
    if (grid.dataset.loadMoreInit === 'true') return;
    grid.dataset.loadMoreInit = 'true';

    var loadMoreBtn = container.querySelector('#loadMore_btn');
    var loadMoreWrapper = container.querySelector('#loadMoreWrapper');
    var loadMoreImage = container.querySelector('.loadMore_image');
    var loadMoreStatus = container.querySelector('#loadMoreStatus');
    var filterForm = container.querySelector('#filter_form');
    var inlineFilters = container.querySelectorAll('.filters-inline > a.filters-inline__item');
    var categorySelect = container.querySelector('select#category');
    var postsPerPageInput = container.querySelector('#posts_per_page')
        || container.querySelector('input[name="posts_per_page"]');

    var ajaxUrl = (window.wondr_ajax && window.wondr_ajax.ajax_url) || '/wp-admin/admin-ajax.php';

    // Determine action from multiple sources
    var action = null;
    if (loadMoreBtn && loadMoreBtn.dataset.action) {
        action = loadMoreBtn.dataset.action;
    } else if (filterForm) {
        var actionInput = filterForm.querySelector('input[name="action"]');
        if (actionInput) action = actionInput.value;
    }
    // Infer from DOM as last resort
    if (!action) {
        if (inlineFilters.length > 0) action = 'filter_conservation';
        else if (categorySelect && !filterForm) action = 'filter_posts';
        else if (filterForm) action = 'filter_animals';
    }
    if (!action) return;

    var postsPerPage = postsPerPageInput
        ? postsPerPageInput.value
        : (loadMoreBtn && loadMoreBtn.dataset.postsPerPage
            ? loadMoreBtn.dataset.postsPerPage
            : '12');

    /** Get the currently active category/filter value */
    function getActiveCategory() {
        if (inlineFilters.length > 0) {
            var active = container.querySelector('.filters-inline > a.filters-inline__item.active');
            return active ? active.dataset.term_id : '0';
        }
        if (categorySelect) {
            return categorySelect.value || '0';
        }
        return '0';
    }

    /**
     * Core data-fetch function.
     */
    async function sendData(opts) {
        var paged = (opts && opts.paged) || 1;
        var more = (opts && opts.more) || false;
        var category = (opts && opts.category !== undefined) ? opts.category : null;

        try {
            var responseJson;

            if (action === 'filter_posts') {
                // Posts archive uses GET
                var cat = category !== null ? category : getActiveCategory();
                var url = ajaxUrl + '?action=filter_posts&page=' + paged
                    + '&category=' + cat + '&post_per_page=' + postsPerPage;
                var resp = await fetch(url, {
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                });
                var raw = await resp.json();
                // Normalise to standard shape
                responseJson = {
                    success: true,
                    data: {
                        list: raw.html,
                        load_more: raw.has_more ? paged + 1 : false
                    }
                };
            } else {
                // Events / Animals / Conservation use POST
                var formData;
                if (filterForm) {
                    formData = new FormData(filterForm);
                } else {
                    formData = new FormData();
                }
                formData.set('action', action);
                formData.set('page', String(paged));

                if (category !== null && action === 'filter_conservation') {
                    formData.set('category_id', category);
                }
                if (postsPerPage && !formData.get('posts_per_page')) {
                    formData.set('posts_per_page', postsPerPage);
                }

                var resp2 = await fetch(ajaxUrl, { method: 'POST', body: formData });
                responseJson = await resp2.json();
            }

            // Hide spinner, restore button
            if (loadMoreImage) loadMoreImage.style.display = 'none';
            if (loadMoreBtn) loadMoreBtn.style.display = '';

            if (responseJson.success && responseJson.data) {
                if (grid && responseJson.data.list) {
                    var previousCount = grid.children.length;

                    if (more) {
                        grid.insertAdjacentHTML('beforeend', responseJson.data.list);
                    } else {
                        grid.innerHTML = responseJson.data.list;
                    }

                    // Accessibility: announce + focus
                    if (more) {
                        var newCount = grid.children.length - previousCount;
                        if (loadMoreStatus) {
                            loadMoreStatus.textContent = newCount + ' more items loaded, ' + grid.children.length + ' now shown';
                        }
                        var firstNew = grid.children[previousCount];
                        if (firstNew) {
                            firstNew.setAttribute('tabindex', '-1');
                            firstNew.focus();
                        }
                    }
                }

                // Update load-more visibility
                if (responseJson.data.load_more === false) {
                    if (loadMoreWrapper) loadMoreWrapper.style.display = 'none';
                } else {
                    if (loadMoreWrapper) loadMoreWrapper.style.display = 'flex';
                    if (loadMoreBtn) loadMoreBtn.setAttribute('data-page', responseJson.data.load_more);
                }
            }

            if (typeof window.initTextAnims === 'function') window.initTextAnims();

        } catch (e) {
            console.error('[LoadMore] Error:', e);
            if (loadMoreImage) loadMoreImage.style.display = 'none';
            if (loadMoreBtn) loadMoreBtn.style.display = '';
        }
    }

    // --- Bind load-more button ---
    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            var paged = parseInt(this.dataset.page) || 2;
            if (loadMoreImage) loadMoreImage.style.display = 'block';
            this.style.display = 'none';
            sendData({ paged: paged, more: true, category: getActiveCategory() });
        });
    }

    // --- Bind filter form submit (events, animals) ---
    if (filterForm) {
        filterForm.addEventListener('submit', function (e) {
            e.preventDefault();
            sendData();
        });
    }

    // --- Bind inline filter links (conservation) ---
    if (inlineFilters.length > 0) {
        inlineFilters.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                inlineFilters.forEach(function (d) { d.classList.remove('active'); });
                this.classList.add('active');
                sendData({ category: this.dataset.term_id });
            });
        });
    }

    // --- Bind category select change (posts — no filter form) ---
    if (categorySelect && !filterForm) {
        categorySelect.addEventListener('change', function () {
            sendData({ category: parseInt(this.value) || 0 });
        });
    }
}
